import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  RotateRightOutlined,
} from "@ant-design/icons";

const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

export default function ImagePreviewer({
  open = false,
  onClose,
  images = [], // ["https://.../a.jpg", "/uploads/b.png", ...]
  startIndex = 0, // аль зургаас эхлэх
  title = "Зураг",
}) {
  const safeImages = useMemo(
    () => (Array.isArray(images) ? images.filter(Boolean) : []),
    [images]
  );

  const [index, setIndex] = useState(startIndex || 0);
  const [zoom, setZoom] = useState(1);
  const [rotate, setRotate] = useState(0);

  useEffect(() => {
    if (!open) return;
    setIndex(clamp(startIndex || 0, 0, Math.max(safeImages.length - 1, 0)));
    setZoom(1);
    setRotate(0);
  }, [open, startIndex, safeImages.length]);

  const hasPrev = index > 0;
  const hasNext = index < safeImages.length - 1;

  const handlePrev = () => {
    if (!hasPrev) return;
    setIndex((i) => i - 1);
    setZoom(1);
    setRotate(0);
  };

  const handleNext = () => {
    if (!hasNext) return;
    setIndex((i) => i + 1);
    setZoom(1);
    setRotate(0);
  };

  const zoomIn = () => setZoom((z) => clamp(z + 0.1, 0.1, 5));
  const zoomOut = () => setZoom((z) => clamp(z - 0.1, 0.1, 5));
  const rotateRight = () => setRotate((r) => r + 90);

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      width={1000}
    >
      {safeImages.length === 0 ? (
        <div className="text-gray-500">Харуулах зураг алга.</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div
            style={{
              width: "100%",
              height: 520,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              borderRadius: 8,
              border: "1px solid #eee",
              background: "#fafafa",
            }}
          >
            <img
              src={safeImages[index]}
              alt={`preview-${index + 1}`}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                transform: `scale(${zoom}) rotate(${rotate}deg)`,
                transition: "transform 0.15s ease",
                userSelect: "none",
              }}
              draggable={false}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            <Button
              shape="circle"
              icon={<LeftOutlined />}
              onClick={handlePrev}
              disabled={!hasPrev}
            />
            <Button icon={<ZoomInOutlined />} onClick={zoomIn} />
            <Button icon={<ZoomOutOutlined />} onClick={zoomOut} />
            <Button icon={<RotateRightOutlined />} onClick={rotateRight} />
            <Button
              shape="circle"
              icon={<RightOutlined />}
              onClick={handleNext}
              disabled={!hasNext}
            />
          </div>

          <div style={{ textAlign: "center", color: "#999" }}>
            {safeImages.length > 1
              ? `${index + 1} / ${safeImages.length}`
              : null}
          </div>
        </div>
      )}
    </Modal>
  );
}
